import { WidgetCard } from '@/components/common/WidgetCard';
import { StatTile } from '@/components/common/StatTile';
import { useStats } from '@/features/dashboard/hooks/useDashboard';
import { formatCount } from '@/lib/format';
import { InboxIcon } from '@/icons';

/** Mailboxes KPI — total mailboxes (+ aliases/forwarders sub), mail-admin /statistics. */
export function MailboxesWidget() {
  const { data, isLoading, isError, refetch } = useStats();
  return (
    <WidgetCard title="Mailboxes" icon={InboxIcon} isLoading={isLoading} isError={isError} onRetry={refetch}>
      {data && (
        <StatTile
          label="Mailboxes"
          value={formatCount(data.mailboxes)}
          accent="success"
          sublabel={`${formatCount(data.aliases)} aliases / ${formatCount(data.forwarders)} forwarders`}
        />
      )}
    </WidgetCard>
  );
}
